/**
 * This is an auto-generated file.
 * Any changes made to this file can be lost when this file is regenerated.
 */

import type { AcceptPrivacyPolicyRequest, ApiPartnership, ApiPermission, ApiUser } from '@Model';
import type { HttpActions, Result } from '@synqo/frontend-component-library';

/**
 * Calls the endpoints of OwnUserController.
 */
export class OwnUserRepository {
    constructor(private readonly http: HttpActions) {}

    /**
     * Calls POST /users/me:accept_privacy_policy
     */
    public acceptPrivacyPolicy(request: AcceptPrivacyPolicyRequest): Promise<Result<ApiUser>> {
        return this.http.post<Result<ApiUser>, AcceptPrivacyPolicyRequest>('/users/me:accept_privacy_policy', request);
    }

    /**
     * Calls GET /users/me
     */
    public getOwnUser(include: string | undefined): Promise<Result<ApiUser>> {
        const query = new URLSearchParams();
        if (include !== undefined) {
            query.set('include', `${include}`);
        }

        return this.http.get<Result<ApiUser>>('/users/me', query);
    }

    /**
     * Calls PUT /users/me
     */
    public updateOwnUser(apiUser: ApiUser): Promise<Result<ApiUser>> {
        return this.http.put<Result<ApiUser>, ApiUser>('/users/me', apiUser);
    }

    /**
     * Calls GET /users/me/permissions
     */
    public getMyPermissions(): Promise<Result<ApiPermission[]>> {
        return this.http.get<Result<ApiPermission[]>>('/users/me/permissions');
    }

    /**
     * Calls GET /users/me/partnership
     */
    public getMyPartnership(): Promise<Result<ApiPartnership>> {
        return this.http.get<Result<ApiPartnership>>('/users/me/partnership');
    }

    /**
     * Calls POST /users/me:reset_password
     */
    public resetUserPassword(): Promise<Result<boolean>> {
        return this.http.post<Result<boolean>, undefined>('/users/me:reset_password', undefined);
    }
}
